<template>
  <v-row justify="center">
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items v-if="false">
            <v-btn dark text @click="dialog = false">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <supplier-details :supplierId="supplierId" :isModal="true"></supplier-details>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SupplierDetails from "../suppliers/SupplierDetails";
export default {
  name: "modal-supplier-edit",
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    value: {
      type: Object,
      default: () => null
    }
  },
  components: {
    SupplierDetails
  },
  computed: {
    title() {
      return this.value && this.value.supplierName != ""
        ? `Editing - ${this.value.supplierName}`
        : "Edit Supplier";
    },
    supplierId() {
      return this.value && this.value.supplierId ? this.value.supplierId : "";
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/ModalSupplierEdit.vue